import React from 'react';
import { Link } from 'react-router-dom';
import TermsAndConditionsLayout from '../../lib/Layout/TermsAndConditionsLayout/TermsAndConditionsLayout';
import styles from './TermsOfServicesPage.module.scss';

export default function TermsOfServicePage() {
  return (
    <TermsAndConditionsLayout title="Terms of Service">
      <div className={styles.container}>
        <h2>Techscrum.com Terms Of Service</h2>
        <p>
          These Terms of Service govern your use of the Techscrum.com platform and all services
          connected to the Techscrum.com platform, including, but not limited to the Techscrum,
          Desk, Chat, Spaces, CRM software products, websites, related mobile or desktop application
          and all integrations. (“Techscrum.com services”), provided by Techscrum.com Ltd.
        </p>
        <h2>Acceptance Of Terms</h2>
        <p>
          This Terms of Service document is an agreement you must accept in order to use
          Techscrum.com&apos;s Services. This is a legal agreement (“Agreement”) between You and
          Techscrum Techscrum Crew Ltd. trading as Techscrum.com (“Company”), for use of any of the
          Techscrum.com services services which You selected or initiated. “You” refers to the
          individual who who registered provided in the Techscrum.com website his or her credit card
          mechanism for the Services or, if the Services are being purchased on behalf of an entity
          individual authorized to purchase the Services on behalf of such entity, then “You” refers
          to such entity.
        </p>
        <p>
          If you are entering into this TOS agreement on behalf of a company or other legal entity,
          you represent that you have the authority to bind such entity to these TOS In that case,
          the terms or shall also refer to such entity, its staff and its affiliates, as applicable.
          If you do not have such authority, or if you do not agree with this TOS, you may not use
          the Service. You acknowledge that this TOS is a contract between you and Techscrum.com,
          even though it is electronic and is not physically signed by you and Techscrum.com, and it
          governs your use of the Service.
        </p>
        <p>
          Violation of any of the terms of service may result in the termination of your account.
        </p>
        <h2>Services</h2>
        <p>
          The Company may at its sole discretion modify the features of the Services from time to
          time without prior notice. Techscrum.com reserves the right at any time and from time to
          time to modify or discontinue, temporarily or permanently, the Service (or any part
          thereof) with or without notice. You agree that Techscrum.com shall not be liable to you
          to any third party for any modification, suspension or discontinuance of the Service.
        </p>
        <p>
          If any users send us any feedback or suggestions regarding the Service, you grant
          Techscrum.com an unlimited, irrevocable, perpetual, free license to use any such feedback
          or suggestions for any purpose without any obligation to you.
        </p>
        <h2>Access To The Services</h2>
        <p>
          You will receive a password and account designation upon completing the Service&apos;s
          registration process. You are responsible for maintaining the confidentiality of the
          password and account and are fully responsible for all activities that occur under your
          password or account. You agree to (a) immediately notify Techscrum.com of any unauthorized
          use of your password or account or any other breach of security; and (b) ensure that you
          exit from your account at the end of each session.
        </p>
        <p>
          You may not use the service for any purpose which is illegal or violates any laws in your
          jurisdiction, in the jurisdiction of the Republic of Ireland or in any way that
          intentionally or unintentionally violates any applicable local, state, national or
          international law.
        </p>
        <p>
          Any software associated with the Services is protected by copyright laws and international
          copyright treaties, as well as other intellectual property laws and treaties.
        </p>
        <h2>Your Content And Data</h2>
        <p>
          We claim no intellectual property rights over the data and material you provide to the
          Service. All materials uploaded remain yours.
        </p>
        <p>
          “Data” means any data and content you upload, post, transmit or otherwise made available
          via the Services including messages you send, files you upload, comments you make on
          files, profile information and anything else you enter or upload into the Service.
          Techscrum.com will make commercially reasonable efforts to ensure that all facilities used
          to store and process Your Data meet a high standard for security. For more information on
          our current practices and policies regarding data privacy, security and confidentiality,
          please see www.Techscrum.com/security; we keep that document updated as these practices
          and policies evolve over time).
        </p>
        <p>
          In order for us to provide services to you, we require that you grant us certain rights
          with respect to your Data. For example, we need to be able to transmit, store and copy
          your Data in order to display it to you and your colleagues, to index it so you are able
          to search it, to make backups to prevent data loss, and so on. Your acceptance of this TOS
          gives us the permission to do so and grants us any such rights necessary to provide the
          service to you, only for the purpose of providing the service (and for no other purpose).
          This permission allowing us to use third-party service providers (for example Amazon Web
          Services) in the operation and administration of the Service and the rights granted to us
          are extended to these third parties to the degree necessary in order for the Service to be
          provided. Depending on the service, this may involve moving your data across
          jurisdictional lines, or across country borders. The Company will not share, disclose,
          sell, lease, modify, delete or distribute any Data provided by you in any manner.
        </p>
        <p>
          The Company will also not view the Data provided by you except when given permission by
          you for the purpose of support.
        </p>
        <p>
          You agree that Techscrum.com may include your business name in a list of Techscrum.com’s
          customers online and in print and electronic marketing materials in an appropriate
          fashion. If you’d prefer to not have your details included please email us at marketing
          Techscrum.com
        </p>
        <h2>Conduct On Techscrum.com</h2>
        <p>You may not use the Techscrum.com Platform to:</p>
        <ul>
          <li>
            <p>
              Upload, post, transmit, or otherwise make available any of Your Data that is unlawful,
              harmful, threatening, abusive, harassing, tortious, defamatory, vulgar, obscene,
              libelous, invasive of another’s privacy, hateful, or racially, ethnically, or
              otherwise objectionable.
            </p>
          </li>
          <li>
            <p>Upload or transmit images that contain nudity, weapons, violence or drugs.</p>
          </li>
          <li>
            <p>Impersonate, or misrepresent your relationship with, any person or entity.</p>
          </li>
          <li>
            <p>
              Upload or transmit any Content that you do not have a right to make available, or that
              infringes any patent, trademark, trade secret, copyright, privacy, or other
              proprietary rights of any party.
            </p>
          </li>
        </ul>
        <p>
          You are solely liable and responsible for your interactions with other users. We reserve
          the right to monitor disputes between you and other users, but we have no obligation to do
          so.
        </p>
        <p>We reserve the right to terminate any account that is in breach of these terms.</p>
        <h2>Billing</h2>
        <p>
          You are not obligated to purchase any of the Services. If You elect to purchase Service
          packages or additional Services, you may elect to provide a credit card or other payment
          mechanism selected by You.
        </p>
        <p>
          You agree that the Company may charge to Your credit card or other payment mechanism
          selected by You and approved by the Company for Your Prepaid Account (“Your Account”) and
          all amounts due and owing for the Services, including service fees, subscription fees or
          any other fee or charge associated with Your use of the Services. If there are any annual,
          monthly or similar periodic fees for Your subscription, these fees will be billed
          automatically to the credit card designated during the registration process for the
          Services, or subsequently designated to the Company at the start of the subscription
          period and at the start of each renewal period, unless You terminate Your subscription
          before the relevant period begins.
        </p>
        <p>
          Prices of all Services are subject to change at any time. The company will strive wherever
          possible to give advance notice. Such notice may be provided at any time by posting the
          changes to the Techscrum.com website or the Service itself.
        </p>
        <p>
          All payments authorized by you into your account are final. There is no refunding of your
          account regardless of whether you use the Services or not.
        </p>
        <p>
          In connection with your purchase and/or use of the Service you may be subject to taxes,
          including, without limitation, sales and use taxes, by any authority which has
          jurisdiction to impose such taxes. You agree that the obligation and payment of any such
          taxes shall be your sole and absolute responsibility, and you agree to indemnify
          Techscrum.com to the extent that Techscrum.com incurs any obligations or other liabilities
          in connection with such taxes.
        </p>
        <p>
          You agree that in the event The Company is unable to collect the fees owed to the Company
          for the Services through your Account, the Company may take any other steps it deems
          necessary to collect such fees from you and that you will be responsible for all costs and
          expenses incurred by the Company in connection with such collection activity, including
          collection fees and legal costs. You further agree that the Company may collect interest
          at the lesser of 1.5% per month or the highest amount permitted by law on any amounts not
          paid when due.
        </p>
        <h2>Changing Your Service Level</h2>
        <p>
          Some services provided by Techscrum.com allow you to upgrade or downgrade your service
          levels.
        </p>
        <p>
          If you upgrade your service level from one package to a higher priced package, the Company
          will charge you thus: If you pay monthly, your first payment will be the difference
          between the higher priced package and your current package price, whereby monies received
          by Company for your current package price is pro-rated based on the actual number of days
          until your scheduled monthly payment date. Your regularly scheduled monthly payment date
          will remain the same as your initial purchase date, with subsequent monthly charges at the
          higher package price.
        </p>
        <p>
          If you purchase or upgrade additional services that are charged on a monthly basis, your
          first payment for those additional services will be the price of the additional services
          pro-rated based on the actual number of days until your next monthly payment date. Your
          scheduled monthly payment date will remain the same as your initial purchase date, with
          the full price of the additional services reflected in subsequent monthly charges. If you
          purchase additional services that are charged on an annual basis, your first payment for
          those additional services will be the full price of the additional service. The renewal
          date for such annual additional services will be the date of upgrade the subsequent year.
        </p>
        <p>
          There are limited package downgrade options available and no refunds. Subscribers that
          wish to move from a higher priced package to a lower priced package must let the current
          service level expire then repurchase at the desired service level (or use the Free version
          if available).
        </p>
        <p>
          Subscribers that wish to remove additional services from their account must let the
          current additional services expire first then repurchase any desired additional services.
          No refunds are available.
        </p>
        <h2>Cancellation Of Account</h2>
        <p>
          You are solely responsible for properly canceling your account. An email or phone request
          to cancel your account is not considered cancellation. You can cancel your account at any
          time by accessing the subscription settings panel in your settings page. PLEASE NOTE: This
          does not apply to Enterprise accounts.
        </p>
        <p>
          All of your content will be immediately inaccessible from the Service upon cancellation.
          Within 30 days, all this content will be permanently deleted from all backups and logs.
          This information can not be recovered once it has been permanently deleted.
        </p>
        <p>
          The Company, in its sole discretion, has the right to suspend or terminate your account
          and refuse any and all current or future use of the Service for any reason at any time.
          Such termination of the Service will result in the deactivation or deletion of your
          Account or your access to your Account, and the forfeiture and relinquishment of all
          content in your account. The Company reserves the right to refuse service to anyone for
          any reason at any time.
        </p>
        <h2>Abuse Of Features</h2>
        <p>
          The features made available through the Techscrum.com services are intended for the normal
          use of the software. Abuse of features may result in a ban or removal of service. (E.g: Do
          not use reply-by-email address in automated systems such as Google Alerts etc. Do not
          auto-direct emails to a specific reply-by-email Techscrum email address) RSS feeds used
          where Techscrum data is published publicly may be disabled. RSS feeds are intended for
          private consumption only.
        </p>
        <p>
          In extreme cases, we reserve the right to temporarily suspend your account if your usage
          significantly exceeds the average usage of other Service customers and/or there’s a danger
          that your usage of the services is causing disruption to other users. We’ll always attempt
          to reach out to the account owner before taking any action except in rare cases where the
          level of use may negatively, immediately impact the performance of the Service for other
          customers.
        </p>
        <h2>No Reselling Or Use Outside Of Permitted Terms</h2>
        <p>
          Other than using the Services as permitted under the terms and conditions of this
          Agreement or other written agreements between you and the Company, You may not resell,
          distribute, make any commercial use of, or use on a time-share or service bureau basis.
        </p>
        <h2>Use Of Third Party Applications And API Access</h2>
        <p>
          If you elect to utilize any third party application in connection with your use of the
          Service, by doing so you are consenting to your Content being shared with such third party
          application. To understand how such third party application provider utilizes your Content
          and other information, you should review their privacy policy.
        </p>
        <p>
          <p className={styles.highlightedText}>
            You expressly understand and agree that the Company shall not be liable for any damages
            or losses resulting from your use of the API or third-party products that access data
            via the API.
          </p>
        </p>
        <p>
          Abuse or excessively frequent requests to the Service via the API may result in the
          temporary or permanent suspension of your account’s access to the API. The Company, in its
          sole discretion, will determine abuse or excessive usage of the API. The Company will make
          a reasonable attempt via email to warn the account owner prior to suspension.
        </p>
        <h2>Proprietary Rights</h2>
        <p>
          The Company and/or its suppliers, as applicable, retain ownership of all proprietary
          rights in the Services and in all trade names, trademarks and service marks associated or
          displayed with the Services. You will not remove, deface or obscure any of the Company’s
          or its suppliers’ copyright or trademark notices and/or legends or other proprietary
          notices on, incorporated therein, or associated with the Services. You may not reverse
          engineer, reverse compile or otherwise reduce to human readable form any software
          associated with the Services.
        </p>
        <h2>Governing Law</h2>
        <p>
          These Terms will be governed by the laws of the Republic of Ireland, without regard to its
          conflict of laws principles.
        </p>
        <h2>Disclaimer limitation of liability</h2>
        <p>
          Disclaimer. Neither any opinion, advice or statement of us or our affiliates, licensors,
          suppliers, agents or visitors, whether made on our website or otherwise nor the results of
          any operation of the service by you constitute representations or warranties of us or give
          rise to any rights of reliance or otherwise for the benefit of you or any third party. You
          are responsible for implementing sufficient procedures and checkpoints to satisfy your
          particular requirements for accuracy of data input and output, and for maintaining a means
          external to this website for the reconstruction of any lost data. We do not assume any
          responsibility or risk for your use of our service and the internet. Any and all services
          provided by us to you are provided “As is”, Without warranty of any kind. We disclaim all
          warranties of any kind, whether express or implied, including but not limited to the
          implied warranties of merchantability, fitness for a particular purpose, satisfactory
          quality and non infringement and all warranties that May arise from course of dealing,
          course of performance or usage of trade. Applicable law may not allow the exclusion of
          implied warranties, so the above exclusions may not apply to you. We and our affiliates,
          licensors, suppliers, and agents do not warrant that your use of our website or materials
          will be uninterrupted, error-free or secure, that defects will be corrected or that our
          website, the server (s) on which our website is hosted or our materials are free of
          viruses or other harmful components. Without limiting the generality of the foregoing, we
          hereby disclaim any and all liability for any damage to or other impact on your equipment,
          hardware, software, data or other information or materials, whether or not caused by or
          related to (either directly or indirectly) your use of the service, including but not
          limited to claims relating to faulty, malfunctioning or inoperable service.
        </p>
        <p>
          Limitation of liability. In no event will we nor any of our affiliates, licensors
          suppliers or agents, nor our or their directors, officers, employees, consultants, agents
          or other representatives (“Indemnified parties”) , Be liable for any indirect, incidental,
          special, consequential or punitive damages or damages for loss of profits, revenue,
          business, savings, data, use or cost of substitute procurement, incurred by you or any
          third party, whether in an action in contract, tort (including negligence) or otherwise,
          even if we have been advised of the possibility of such damages or if such damages are
          foreseeable. Your sole remedy for dissatisfaction with our website, materials or any
          linked site is to stop using them. The sole and exclusive maximum liability of all
          indemnified parties collectively for all damages, losses and causes of action, whether in
          contract, tort (including negligence) or otherwise, shall be the total amount paid by you,
          if any, to access or use our website or our materials. Your use of our website and any
          materials provided through our website is entirely at your own risk. You acknowledge that
          the limitations of liability in these terms and the allocation of risk herein are an
          essential element of the bargain between you and us, without which we would not have
          provided the service. Our pricing reflects this allocation of risk and the limitation of
          liability specified herein.
        </p>
        <p>
          Errors. A possibility exists that our website or materials could include inaccuracies or
          errors or information or materials that violate these terms. Additionally, a possibility
          exists that unauthorized alterations could be made by third parties to our website or
          materials. Although we attempt to ensure the integrity of our website, we make no
          guarantees as to its completeness or correctness. If a situation arises in which our
          website’s completeness or correctness is in question, please contact us via our contact
          information provided on our&nbsp;
          <Link to="/terms-of-service">Support</Link>
          &nbsp;page of the website with, if possible, a description of the material to be checked
          and the location (url) where such material can be found on our website.
        </p>
        <p>
          If you have any questions regarding this agreement or if you wish to discuss the terms of
          service contained herein please contact Techscrum.com limited using the contact details at
          our&nbsp;
          <Link to="/terms-of-service">Contact</Link>
          &nbsp;page.
        </p>
      </div>
    </TermsAndConditionsLayout>
  );
}
